import Axios from "axios";
import {
  SET_ATTENDANCE_SUMMARY_REPORT,
  UNSET_ATTENDANCE_SUMMARY_REPORT,
} from "@/store/mutation-types";
import {
  getAttendanceSummaryReport,
} from "@/store/api";

const state = {
  attendanceSummaryReport: [],
};

const getters = {
  getAttendanceSummaryReport(state) {
    return state.attendanceSummaryReport;
  },
};

const mutations = {
  [SET_ATTENDANCE_SUMMARY_REPORT](state, data) {
    state.attendanceSummaryReport = data;
  },
  [UNSET_ATTENDANCE_SUMMARY_REPORT](state) {
    state.attendanceSummaryReport = [];
  },
};

const actions = {
  getAttendanceSummary({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAttendanceSummaryReport}`, { params: data })
        .then((response) => {
          commit(SET_ATTENDANCE_SUMMARY_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ATTENDANCE_SUMMARY_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

